import type { EChartsTheme, FormatAmount, PrivacyMask } from '../types';

export const buildMarkLine = (
  monthlyAverage: number,
  theme: EChartsTheme,
  formatAmount: FormatAmount,
  privacyMask: PrivacyMask,
) => {
  // monthlyAverage may be stored as negative (expense); chart values are positive
  const absValue = Math.abs(monthlyAverage);
  const formatted = String(privacyMask(formatAmount(absValue, 'USD', '0,0')));
  const color = theme.averageLineColor ?? '#FF7043';
  return {
    symbol: ['none', 'none'],
    silent: true,
    lineStyle: { color, type: 'solid', width: 2, opacity: 0.8 },
    label: {
      show: true,
      formatter: formatted,
      color: theme.bgColor ?? '#fff',
      backgroundColor: color,
      padding: [2, 6],
      borderRadius: 4,
      position: 'start',
      fontSize: 11,
    },
    data: [{ yAxis: absValue }],
  };
};
